import React from 'react';
import TriStateCheckbox from 'src/modules/shared/components/atoms/inputs/tri-state-checkbox';

interface PropertyFeatureStateControlProps {
  /** Feature name, shown next to the box and used as the accessible name. */
  label: string;
  /** Current value: `true`, `false`, or `null` when it is not set. */
  value: boolean | null;
  /** Called with the next value in the cycle. */
  onChange: (value: boolean | null) => void;
  /** Returns the hover hint for the value the next click sets. */
  getHint: (nextValue: boolean | null) => string;
  /** Id of the legend that explains the states. */
  legendId: string;
  /** Whether the control is disabled. */
  disabled?: boolean;
}

/**
 * Catalog wrapper around the shared tri-state checkbox: a full clickable row
 * with the box to the left of the feature name.
 */
export const PropertyFeatureStateControl: React.FC<
  PropertyFeatureStateControlProps
> = ({ label, value, onChange, getHint, legendId, disabled = false }) => (
  <TriStateCheckbox
    ariaLabel={label}
    label={label}
    value={value}
    onChange={onChange}
    getHint={getHint}
    ariaDescribedBy={legendId}
    disabled={disabled}
    size="sm"
    variant="primary"
  />
);
